import type { BaseHeaderProps } from "./BaseHeader.type";

import { Typography, Spin } from "antd";
import classNames from "classnames";

import { useThemeBreakpoints } from "@/services/theme";

import HeaderLogo from "./HeaderLogo";
import "./Header.style.less";

const BaseHeader = ({
  title,
  logo,
  beforeTitle,
  afterTitle,
  extra = [],
  breadcrumb,
  loading,
  headerClass,
  wrapExtra = false,
}: BaseHeaderProps) => {
  const { md } = useThemeBreakpoints();

  const smallScreen = !md;
  const wrap = wrapExtra || smallScreen ? true : false;
  const extraStyle =
    typeof wrapExtra === "number" ? { flexBasis: wrapExtra } : undefined;

  return (
    <header className={classNames("header", { [headerClass!]: headerClass })}>
      {loading ? (
        <Spin />
      ) : (
        <>
          <div className="header-top">
            <div className="header-top-left">
              {logo?.url && (
                <div>
                  <HeaderLogo path={logo.url} />
                </div>
              )}
              {beforeTitle}
              <div className="header-title">
                <Typography.Title
                  ellipsis={{
                    rows: 1,
                    tooltip: { title, placement: "bottom" },
                  }}
                >
                  {title}
                </Typography.Title>
              </div>
              {afterTitle}
            </div>
            {extra && (
              <div
                className={classNames("header-top-right", { "-wrap": wrap })}
                style={extraStyle}
              >
                {extra}
              </div>
            )}
          </div>
          {breadcrumb && <div className="header-breadcrumb">{breadcrumb}</div>}
        </>
      )}
    </header>
  );
};

export default BaseHeader;
